import { useRef } from 'react';

import DoneCheck from '@crm/shared/assets/icons/done-check.svg?react';
import noLogoCompanySrc from '@crm/shared/assets/icons/no-logo-company.png';
import { cn, useIsClamped } from '@crm/shared/lib';

import type { TCompany } from '@crm/entities/company';

export const CompanyItem = (companyData: TCompany) => {
    const title = companyData.title ?? companyData.ownerEmail;
    const titleRef = useRef<HTMLHeadingElement>(null);
    const emailRef = useRef<HTMLParagraphElement>(null);
    const isTitleClamped = useIsClamped(titleRef);
    const isEmailClamped = useIsClamped(emailRef);

    return (
        <div className={cn('w-full list-none')}>
            <div className="flex items-center gap-3 px-2 pt-1 pb-1">
                <div className="flex size-6.5 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#EAEBED]">
                    <img
                        src={companyData.logoUrl ?? noLogoCompanySrc}
                        alt=""
                        className="size-3 object-contain"
                    />
                </div>
                <div className="flex min-w-0 flex-1 flex-col items-start py-[4.5px]">
                    <h6
                        ref={titleRef}
                        title={isTitleClamped ? title : undefined}
                        className={cn(
                            'm-0 w-full truncate text-xs font-normal text-gray-800',
                            companyData.isActive && 'font-medium'
                        )}
                    >
                        {title}
                    </h6>
                    {companyData.title && (
                        <p
                            ref={emailRef}
                            title={isEmailClamped ? companyData.ownerEmail : undefined}
                            className="m-0 w-full truncate text-[10px] text-slate-500"
                        >
                            {companyData.ownerEmail}
                        </p>
                    )}
                </div>
                {companyData.isActive && (
                    <span className="ml-auto flex size-6.5 shrink-0 items-center justify-center">
                        <DoneCheck aria-hidden="true" className="h-[15px] w-[19px]" />
                    </span>
                )}
            </div>
        </div>
    );
};
